import React from 'react';
import AbstractForm from 'components/AbstractForm';
import Autocomplete from 'components/autocomplete';
import DataSource from 'services/DataSource';

export default class ExpertForm extends AbstractForm {

  constructor(props) {
    super(props);
    this.state.countries = [];
  }

  getFormData() {
    const resource = DataSource.getSource('countries', 'countries{/:id}.json', 'country');
    resource.query().then(({items}) => {
      if (this.mounted) {
        this.setState( { countries: items } );
      }
    });
  }
  
  renderFields() {
    const { item } = this.state;
    return [
        <div className="row" key="name">
          <div className="col-sm-12 mb-3">
            <label htmlFor="name">Имя</label>
            <input id="name" name="name" className="form-control" value={item.name} onChange={this.propertyChanged} />
          </div>
        </div>
      ,
        <div className="row" key="country_id">
          <div className="col-sm-12 mb-3">
            <label htmlFor="country_id">Страна</label>
            <Autocomplete items={this.state.countries} name="country_id" value={item.country_id} 
            getValue={item => item.id} getLabel={item => item.title} onChange={this.propertyChanged} />
          </div>
        </div>
      ,
        <div className="row" key="address">
          <div className="col-sm-12 mb-3">
            <label htmlFor="address">Адрес</label>
            <input id="address" name="address" className="form-control" value={item.address} onChange={this.propertyChanged} />
          </div>
        </div>
      ,
        <div className="row" key="phones">
          <div className="col-sm-12 mb-3">
            <label htmlFor="phones">Телефоны</label>
            <input id="phones" name="phones" className="form-control" value={item.phones} onChange={this.propertyChanged} />
          </div>
        </div>
      ,
        <div className="row" key="email">
          <div className="col-sm-12 mb-3">
            <label htmlFor="email">Адрес e-mail</label>
            <input id="email" name="email" className="form-control" value={item.email} onChange={this.propertyChanged} />
          </div>
        </div>
    ];
  }

}